import {HTMLAttributes} from 'react';
import {UrlLink} from '../../../applink/UrlLink';
import {tt} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {GnbMenuId} from '../../../domain/menu/constant';
import {GnbMenuItem} from '../../../domain/menu/type';
import {getGnbMenuActionName} from '../../../domain/menu/util/getGnbMenuActionName';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {Text} from '../../atoms/Text/Text';

export interface MobileTopMainHomeTabProps
  extends HTMLAttributes<HTMLDivElement> {
  tabItems: GnbMenuItem[];
  currentTabItemId: string;
}

export function MobileTopMainHomeTab({
  tabItems,
  currentTabItemId,
  className,
  ...props
}: MobileTopMainHomeTabProps) {
  if (!tabItems) {
    return null;
  }

  return (
    <div
      className={twMerge(
        'relative flex h-32pxr w-full bg-theme-bg-base',
        className
      )}
      {...props}
    >
      <div className="flex h-full w-full space-x-10pxr px-18pxr">
        {tabItems.map((tabItem, index) => {
          const isSelected = currentTabItemId === tabItem.id;
          return (
            <div
              key={tabItem.text}
              className="relative flex items-start justify-center shrink-0"
            >
              <UrlLink
                url={tabItem.href}
                // href가 있는 경우 a태그로 래핑되기 때문에 linkCss에 탭 아이템 스타일을 넣어줍니다.
                linkClassName="z-10 shrink-0"
              >
                <div
                  className={twMerge(
                    'flex cursor-pointer select-none items-start justify-center',
                    isSelected
                      ? 'font-large4-bold text-theme-solid-100'
                      : 'font-large4 text-theme-solid-40'
                  )}
                  onClick={e => {
                    LOG_CLICK_EVENT(
                      getGnbMenuActionName(tabItem.id as GnbMenuId),
                      e
                    );
                  }}
                  {...putTiaraObjectProps({
                    click: {
                      layer1: '홈메뉴',
                      copy: tabItem.text,
                      ordnum: String(index + 1),
                    },
                  })}
                >
                  <Text className="inline-block whitespace-nowrap text-center">
                    {isSelected && <Text className="blind">선택됨, </Text>}
                    {tt(tabItem)}
                    <Text className="blind">
                      탭, {`총 ${tabItems.length}개 중 ${index + 1}번째`}
                    </Text>
                  </Text>
                </div>
              </UrlLink>
            </div>
          );
        })}
      </div>
    </div>
  );
}
